import classes from "./Select.module.css";
import { useEffect, useState } from "react";
import { nanoid } from "nanoid";
import CustomIcon from "../CustomIcon/CustomIcon";
import arrow_down from "../../../assets/icons/chevron_arrow.svg";
import classnames from "classnames";

/*
 *
 * Created on Thu 12 May 2023
 *
 * Copyright (c) 2023 One97 communications
 * @author poonam.chandra
 * @modified By :
 *
 */

function Select({
  name,
  value,
  label = "",
  placeholder = "Placeholder",
  width = "100%",
  isRequired = false,
  className,
  style = {},
  errormsg,
  errorStyle = {},
  labelStyle = {},
  background = "#FFFFFF",
  borderColor = "#CBD5E1",
  options = [],
  onChange,
}) {
  const [selected, setSelected] = useState(placeholder);
  const [isPlaceholder, setIsPlaceholder] = useState(true);
  const [active, setActive] = useState(false);

  useEffect(() => {
    for (let index = 0; index < options.length; index++) {
      const element = options[index];
      if (value === element.value) {
        if (value !== placeholder) {
          setIsPlaceholder(false);
        } else {
          setIsPlaceholder(true);
        }
        setSelected(element.label);
      }
    }
  }, [value]);

  return (
    <div
      className={`${classes.inputBox} ${className}`}
      style={{ background, width, ...style }}
    >
      <label className={classes.inputlabel} style={{ ...labelStyle }}>
        {label}
        {isRequired && (
          <b style={{ color: "#F42820", paddingLeft: "4px" }}>*</b>
        )}
      </label>
      <div className={classes.dropdown} onClick={() => setActive(!active)}>
        <input type="checkbox" className={classes.dropdown__switch} hidden />
        <CustomIcon
          src={arrow_down}
          alt="Arrow"
          className={classes.dropdown__icon}
        />
      </div>
      <ul
        className={classes.dropdown__filter}
        style={{ border: `1px solid ${borderColor}` }}
        role="listbox"
        onClick={() => setActive(!active)}
        onMouseLeave={() => setActive(false)}
      >
        <li
          className={`${
            isPlaceholder
              ? classes.dropdown__filter__placeholder
              : classes.dropdown__filter__text
          }`}
        >
          {selected}
        </li>
        <li className={classes.dropdown__select__list}>
          <ul
            className={classnames(
              classes.dropdown__select,
              active && classes.active
            )}
          >
            {options.map((element) => {
              return (
                <li
                  className={classes.dropdown__select__option}
                  role="option"
                  value={element.value}
                  key={nanoid()}
                  onClick={() =>
                    onChange({ target: { name: name, value: element.value } })
                  }
                >
                  {element.label}
                </li>
              );
            })}
          </ul>
        </li>
      </ul>
      <label className={classes.error} style={{ ...errorStyle }}>
        {errormsg}
      </label>
    </div>
  );
}

export default Select;
